import { createRouter, createWebHistory } from "vue-router";

import Home from "../views/HomeView.vue";
import Gallery from "../views/GalleryView.vue";
import Menu from "../views/MenuView.vue";
import Contact from "../views/ContactView.vue";

const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/gallery", name: "Gallery", component: Gallery },
  { path: "/menu", name: "Menu", component: Menu },
  { path: "/contact", name: "Contact", component: Contact }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

export default router;
